// extracted by mini-css-extract-plugin
export var menuIcon = "_ny-0";
export var menuIconInline = "_ny-1";